// Global state to track initialization
let isDataInitialized = false;
let dataInitializationPromise = null;
let selectedValues = [];
let updateTimeout = null; // Variable to hold the timeout ID

// Function to handle the actual data fetching with error handling
async function fetchMetaobjects(afterCursor) {
  try {
    const response = await fetch('/api/2023-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '93f4b6da6db6af6c2070a8438579688b',
      },
      body: JSON.stringify({
        query: `
          query {
            metaobjects(type: "shopify--color-pattern", first: 250${afterCursor ? `, after: "${afterCursor}"` : ''}) {
              edges {
                node {
                  fields {
                    key
                    value
                  }
                }
              }
              pageInfo {
                hasNextPage
                endCursor
              }
            }
          }
        `,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP error! status: ${response.status}, body: ${errorText}`);
    }

    return response.json();
  } catch (error) {
    console.error('Fetch error:', error);
    throw error;
  }
}

// Main function to fetch and process data
async function fetchAndProcessMetaobjects() {
  try {
    const cacheKey = 'metaobjectDataCache';
    const cachedData = localStorage.getItem(cacheKey);

    if (cachedData) {
      console.log('Using cached metaobject data');
      return JSON.parse(cachedData);
    }

    let allMetaobjects = [];
    let hasNextPage = true;
    let afterCursor = null;

    while (hasNextPage) {
      const data = await fetchMetaobjects(afterCursor);
      allMetaobjects.push(...data.data.metaobjects.edges);
      hasNextPage = data.data.metaobjects.pageInfo.hasNextPage;
      afterCursor = data.data.metaobjects.pageInfo.endCursor;
    }

    const groupedData = allMetaobjects
      .map((meta) => {
        const fields = meta.node.fields;
        const colorTaxonomyField = fields.find((f) => f.key === 'color_taxonomy_reference');
        const labelField = fields.find((f) => f.key === 'label');
        return colorTaxonomyField && labelField
          ? { key: colorTaxonomyField.value, value: labelField.value }
          : null;
      })
      .filter(Boolean);

    const result = [];
    groupedData.forEach((item) => {
      const existingGroup = result.find((group) => group.key === item.key);
      if (existingGroup) {
        existingGroup.values.push(item.value);
      } else {
        result.push({ key: item.key, values: [item.value] });
      }
    });

    localStorage.setItem(cacheKey, JSON.stringify(result));
    console.log('Data cached successfully');
    return result;
  } catch (error) {
    console.error('Error processing metaobjects:', error);
    return [];
  }
}

// Function to initialize data
async function initializeData() {
  if (isDataInitialized) return;

  try {
    console.log('Initializing data...');
    window.metaobjectColorData = await fetchAndProcessMetaobjects();
    isDataInitialized = true;
    console.log('Data initialized successfully');
  } catch (error) {
    console.error('Error initializing data:', error);
    isDataInitialized = false;
  }
}

function updateGridWithSelectedColors() {
  const interval = setInterval(() => {
    let gridItems = document.querySelectorAll('.grid__item');
    let allUpdated = true;

    gridItems.forEach((gridItem) => {
      const checkedInput = Array.from(gridItem.querySelectorAll('.ctm_variant_spans input[type="radio"]')).find((input) => {
        const spanId = input.closest('.ctm_variant_spans').id;

        if (selectedValues.some((color) => spanId.includes(color))) {
          input.checked = true;
          return true;
        }
        return false;
      });

      if (checkedInput) {
        const imageSrc = checkedInput.dataset.image;
        if (imageSrc) {
          gridItem.querySelectorAll('.media img').forEach((mediaImage) => {
            mediaImage.src = imageSrc;
            mediaImage.srcset = `${imageSrc} 1x`;
          });
        }
      } else {
        allUpdated = false;
      }
    });

    if (allUpdated) {
      clearInterval(interval);
    }
  }, 500);
}

function setupSwatchHandlers() {
  const selectedColors = new Set();

  $(document).on('change', '.swatch-input-wrapper input', async function () {
    if (!isDataInitialized) {
      console.log('Waiting for data initialization...');
      await dataInitializationPromise;
    }

    const colorValue = $(this).val();

    if ($(this).prop('checked')) {
      selectedColors.add(colorValue);
    } else {
      selectedColors.delete(colorValue);
    }

    const selectedColorsArray = Array.from(selectedColors);

    const finalArray = window.metaobjectColorData.filter((item) =>
      selectedColorsArray.some((color) => item.key.includes(color))
    );

    selectedValues = finalArray.flatMap((item) => item.values);

    updateGridWithSelectedColors();
  });

  // Handle page refresh and initialize the selected state
  document.querySelectorAll('.swatch-input-wrapper input:checked').forEach(async (input) => {
    const colorValue = input.value;
    selectedColors.add(colorValue);

    if (!isDataInitialized) {
      console.log('Waiting for data initialization...');
      await dataInitializationPromise;
    }

    const finalArray = window.metaobjectColorData.filter((item) =>
      Array.from(selectedColors).some((color) => item.key.includes(color))
    );

    selectedValues = finalArray.flatMap((item) => item.values);
    updateGridWithSelectedColors();
  });
}

function observeDOMChanges() {
  const targetNode = document.body;
  const observer = new MutationObserver(() => {
    setupSwatchHandlers();
    updateGridWithSelectedColors();
  });

  observer.observe(targetNode, {
    childList: true,
    subtree: true,
  });
}

// Initialize everything when the document is ready
document.addEventListener('DOMContentLoaded', async () => {
  dataInitializationPromise = initializeData();

  setupSwatchHandlers();
  observeDOMChanges();


// Window click event listener
window.addEventListener('click', async (event) => {
  if (!isDataInitialized) {
    console.log('Waiting for data initialization...');
    await dataInitializationPromise;
  }
  //setTimeout(updateGridWithSelectedColors, 2500);
});

// Window change event listener
window.addEventListener('change', async (event) => {
  if (!isDataInitialized) {
    console.log('Waiting for data initialization...');
    await dataInitializationPromise;
  }
 // setTimeout(updateGridWithSelectedColors, 2500);
});
});